import { type SimpleUser } from '@models/SimpleUser';

export function capitalizeString(str: string): string {
    const newStr = str.toLowerCase();
    return newStr.charAt(0).toUpperCase() + newStr.slice(1);
}

export function simplePluralize(input: string, count: number): string {
    return count === 0 || count > 1 ? `${input}s` : input;
}

export function fullName(
    actor: SimpleUser | undefined | null,
): string {
    if (!actor) {
        return '-';
    }

    const { firstName, lastName } = actor;
    return firstName && lastName ? `${firstName} ${lastName}` : '-';
}

export function toKebabCase(str: string): string {
    return str
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
}
